module.exports = __webpack_public_path__ + "static/media/cyklopas-logo-text-cinv-vertical.c8ee9a56.svg";